// Advisor review slider – parts/advisor-reviews-slider.php (city pages + homepage)
import Swiper from '../vendor/swiper/swiper.min';

export default function initAdvisorReviews() {
	if (!document.querySelector('.advisor-reviews__container')) return;

	document.querySelectorAll('.advisor-reviews').forEach(function (wrap) {
		const isHome = wrap.classList.contains('advisor-reviews--home');
		// arrows may live outside the slider (homepage heading) inside a scope element
		const scope = wrap.closest('[data-advisor-reviews-scope]') || wrap;

		// The global lazy loader only sees images that scroll into view vertically;
		// off-screen slides would load on swipe and flash the placeholder.
		// Load every photo in the slider once the slider is near the viewport.
		const loadAllImages = function () {
			wrap.querySelectorAll('img.lazy').forEach(function (img) {
				if (img.dataset.srcset) img.srcset = img.dataset.srcset;
				if (img.dataset.src) img.src = img.dataset.src;
				img.classList.remove('lazy');
			});
		};
		if ('IntersectionObserver' in window) {
			const io = new IntersectionObserver(function (entries) {
				if (entries.some(function (e) { return e.isIntersecting; })) {
					loadAllImages();
					io.disconnect();
				}
			}, { rootMargin: '400px 0px' });
			io.observe(wrap);
		} else {
			loadAllImages();
		}

		new Swiper(wrap.querySelector('.advisor-reviews__container'), {
			slidesPerView: isHome ? 4 : 3,
			spaceBetween: isHome ? 15 : 24, // home: same gap as "Våra tjänster"
			grabCursor: true,
			watchOverflow: true,
			navigation: {
				nextEl: scope.querySelector('.js-advisor-reviews-next, .advisor-reviews__nav--next'),
				prevEl: scope.querySelector('.js-advisor-reviews-prev, .advisor-reviews__nav--prev'),
			},
			// Swiper 4: breakpoints are max-width
			breakpoints: isHome ? {
				// whole cards from 720px; below that the same settings as
				// "Hur kan vi hjälpa dig?" so the cards get the same width
				1199: { slidesPerView: 3, spaceBetween: 15 },
				959: { slidesPerView: 2, spaceBetween: 15 },
				719: { slidesPerView: 2.3, spaceBetween: 15 },
				576: { slidesPerView: 1.3, spaceBetween: 15, slidesOffsetBefore: 10, slidesOffsetAfter: 10 },
			} : {
				1199: { slidesPerView: 2, spaceBetween: 20 },
				719: { slidesPerView: 1.1, spaceBetween: 12 },
			},
		});
	});

	// "Ring <name>": reveal the (CTM-tracked) number, then let the tel: link dial
	$(document).on('click', '.advisor-review__call', function () {
		const $btn = $(this);
		if ($btn.data('revealed')) return;
		const number = $('.organiser-telnum').first().text().trim() || '020-82 82 82';
		const href = $('.organiser-telnum').closest('a[href^="tel"]').first().attr('href') || 'tel:+4620828282';
		$btn.data('revealed', true).removeClass('gtm-strongintent');
		$btn.find('.advisor-review__call-label').html('<a href="' + href + '">' + number + '</a>');
		if (window.__ctm) { window.__ctm.main.runNow(); }
	});
}
